import { useEffect, useState } from "react";
import api from "../../api/api";
import { getPracticeId } from "../../config/practice";
import { bppMasterToReadings } from "./monthlyAverages";

// The RPM list's thumbnails need more than the list row carries (rpm/get only
// sends this month's readings), so each card asks bpp-master, the same
// source as the patient's RPM chart, for the newest readings. One request
// per patient per few minutes: cards re-render on every list reload and
// infinite-scroll step, and the answer is shared through this cache.
const TTL_MS = 5 * 60 * 1000;
const cache = new Map(); // key -> { at, promise }

export function fetchBppHistory(patientid) {
  const key = `${getPracticeId()}:${patientid}`;
  const hit = cache.get(key);
  if (hit && Date.now() - hit.at < TTL_MS) return hit.promise;
  const promise = api
    .post(`/v1/${getPracticeId()}/patient/${patientid}/rpm/bpp-master`, {})
    .then((response) =>
      response && response.status === 200
        ? { readings: bppMasterToReadings(response.data), totalcount: response.totalcount }
        : { readings: [], totalcount: 0 }
    )
    .catch(() => {
      cache.delete(key); // try again next time
      return null;
    });
  cache.set(key, { at: Date.now(), promise });
  return promise;
}

export function clearBppHistoryCache() {
  cache.clear();
}

// -> null while loading / on error, else { readings, totalcount }.
export default function useBppHistory(patientid) {
  const [history, setHistory] = useState(null);
  useEffect(() => {
    if (patientid === undefined || patientid === null || patientid === "") {
      setHistory(null);
      return undefined;
    }
    let live = true;
    setHistory(null);
    fetchBppHistory(patientid).then((h) => {
      if (live) setHistory(h);
    });
    return () => {
      live = false;
    };
  }, [patientid]);
  return history;
}
